// ISO 3166-1 alpha-3 to alpha-2 mapping for maritime flag states
const ALPHA3_TO_ALPHA2 = {
  AFG:'af',AGO:'ao',AIA:'ai',ALB:'al',AND:'ad',ARE:'ae',ARU:'aw',ASM:'as',
  ATG:'ag',AUS:'au',AUT:'at',AZE:'az',BGD:'bd',BHR:'bh',BHS:'bs',BIH:'ba',
  BLR:'by',BLZ:'bz',BMU:'bm',BRB:'bb',BRN:'bn',BTN:'bt',BWA:'bw',BGR:'bg',
  BDI:'bi',BEL:'be',BEN:'bj',BFA:'bf',CAF:'cf',CAN:'ca',CCK:'cc',CHE:'ch',
  CHL:'cl',CHN:'cn',CIV:'ci',CMR:'cm',COD:'cd',COG:'cg',COK:'ck',COM:'km',
  CPV:'cv',CRI:'cr',CUB:'cu',CUW:'cw',CXR:'cx',CYM:'ky',CYP:'cy',CZE:'cz',
  DEU:'de',DJI:'dj',DMA:'dm',DNK:'dk',DOM:'do',DZA:'dz',EGY:'eg',ERI:'er',
  ESP:'es',EST:'ee',ETH:'et',FIN:'fi',FJI:'fj',FRO:'fo',FRA:'fr',FSM:'fm',
  GAB:'ga',GBR:'gb',GEO:'ge',GHA:'gh',GIB:'gi',GIN:'gn',GLP:'gp',GMB:'gm',
  GNQ:'gq',GRC:'gr',GRD:'gd',GRL:'gl',GTM:'gt',HKG:'hk',HND:'hn',HRV:'hr',
  HTI:'ht',HUN:'hu',IDN:'id',IND:'in',IRL:'ie',IRN:'ir',IRQ:'iq',ISL:'is',
  ISR:'il',ITA:'it',JAM:'jm',JOR:'jo',JPN:'jp',KAZ:'kz',KEN:'ke',KGZ:'kg',
  KHM:'kh',KIR:'ki',KNA:'kn',KOR:'kr',KWT:'kw',LAO:'la',LBN:'lb',LBR:'lr',
  LCA:'lc',LIE:'li',LKA:'lk',LSO:'ls',LTU:'lt',LUX:'lu',LVA:'lv',MAC:'mo',
  MAR:'ma',MCO:'mc',MDA:'md',MDG:'mg',MDV:'mv',MEX:'mx',MHL:'mh',MKD:'mk',
  MLI:'ml',MLT:'mt',MMR:'mm',MNE:'me',MNG:'mn',MOZ:'mz',MRT:'mr',MSR:'ms',
  MTQ:'mq',MUS:'mu',MWI:'mw',MYS:'my',MYT:'yt',NAM:'na',NCL:'nc',NGA:'ng',
  NIC:'ni',NIU:'nu',NLD:'nl',NOR:'no',NPL:'np',NRU:'nr',NZL:'nz',OMN:'om',
  PAK:'pk',PAN:'pa',PCN:'pn',PER:'pe',PHL:'ph',PLW:'pw',PNG:'pg',POL:'pl',
  PRK:'kp',PRI:'pr',PRT:'pt',PSE:'ps',PYF:'pf',QAT:'qa',REU:'re',ROU:'ro',
  RUS:'ru',RWA:'rw',SAU:'sa',SEN:'sn',SGP:'sg',SHN:'sh',SLB:'sb',SLE:'sl',
  SLV:'sv',SMR:'sm',SOM:'so',SPM:'pm',SRB:'rs',SSD:'ss',STP:'st',SDN:'sd',
  SVK:'sk',SVN:'si',SWE:'se',SWZ:'sz',SYC:'sc',SYR:'sy',TCA:'tc',TGO:'tg',
  THA:'th',TJK:'tj',TKM:'tm',TON:'to',TTO:'tt',TUN:'tn',TUR:'tr',TUV:'tv',
  TWN:'tw',TZA:'tz',UGA:'ug',UKR:'ua',URY:'uy',USA:'us',UZB:'uz',VAT:'va',
  VCT:'vc',VEN:'ve',VGB:'vg',VIR:'vi',VNM:'vn',VUT:'vu',WLF:'wf',WSM:'ws',
  YEM:'ye',ZAF:'za',ZMB:'zm',ZWE:'zw',PRY:'py',ECU:'ec',COL:'co',BOL:'bo',
  ARG:'ar',BRA:'br',GUY:'gy',SUR:'sr',TLS:'tl',
};

/**
 * Build a flag image URL from an ISO 3166-1 alpha-3 country code.
 * Returns null if the code is unknown.
 */
export function getFlagUrl(alpha3Code) {
  if (!alpha3Code) return null;
  const alpha2 = ALPHA3_TO_ALPHA2[alpha3Code.toUpperCase()];
  if (!alpha2) return null;
  return `https://flagcdn.com/w40/${alpha2}.png`;
}
